import { css } from "@emotion/react";
import React from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../../Shared/Loading";
import { useAccounts } from "../api/accounts";

export default function SelectAccount() {
    // TODO: there could be an admin mode that just lets you search for
    // accounts (and maybe saves recent ones in local storage?).

    const navigate = useNavigate();

    const { isLoading, data: accounts } = useAccounts();
    const onlyOneAccount = accounts && accounts.length == 1;

    useEffect(
        () => {
            if (onlyOneAccount) {
                navigate(accounts[0].accountID, { replace: true });
            }
        },
        [accounts, onlyOneAccount]
    );

    if (isLoading) return <Loading />;

    return accounts.length > 0 ? (
        <>
            <Helmet>
                <title>Select an account - Podtrac</title>
            </Helmet>
            <h1>Select an account:</h1>
            <ul
                css={css`
                    display: grid;
                    list-style: none;
                    grid-template-columns: repeat(auto-fill, minmax(32ch, 1fr));
                    grid-auto-rows: 1fr;
                    gap: 1rem;
                    margin: 0;
                    padding: 0;
                    & li {
                        margin: 0;
                        padding: 0;
                    }
                    & a {
                        border: 4px solid #ddd;
                        border-radius: 1rem;
                        padding: 2rem;
                        font-weight: 600;
                        font-size: 1.25rem;
                        line-height: 2rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        height: 100%;
                        text-decoration: none;
                        font-size: 1.5rem;
                        transition: all 0.2s;

                        &: hover {
                            border-color: #ccc;
                            background-color: #fafafa;
                        }
                    }
                `}
            >
                {accounts.map(a => (
                    <li key={a.accountID}>
                        <Link to={`${a.accountID}`}>{a.accountName}</Link>
                    </li>
                ))}
            </ul>
        </>
    ) : accounts.length == 0 ? (
        <h1>No publisher accounts found.</h1>
    ) : null;
}
